import { Button } from 'antd'
import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import success from "../../assets/success.svg"

export default class TicketDone extends Component {
    render() {
        const {currentLang, localization} = this.props;
        return (
            <div className="ticket-done-wrapper">
                <img src={success} alt="success" /> 
                    <h4>{localization.ThankContactingUs[currentLang]}</h4>
                    <p>{localization.WeWillReview[currentLang]}</p>
                    <Button className="primary-light" size="large" type="primary">
                        <Link to="/">{localization.BackToHome[currentLang]}</Link>
                    </Button>
            </div>
        )
    }
}
